var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWithdraw(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "svg-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6534 27.68C20.4001 27.68 20.1467 27.5867 19.9467 27.3867C19.5601 27 19.5601 26.36 19.9467 25.9734L26.6267 19.2934C27.0134 18.9067 27.6534 18.9067 28.0401 19.2934C28.4267 19.68 28.4267 20.32 28.0401 20.7067L21.3601 27.3867C21.1601 27.5734 20.9067 27.68 20.6534 27.68Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3332 20.9867H4.6665C4.11984 20.9867 3.6665 20.5334 3.6665 19.9867C3.6665 19.44 4.11984 18.9867 4.6665 18.9867H27.3332C27.8798 18.9867 28.3332 19.44 28.3332 19.9867C28.3332 20.5334 27.8798 20.9867 27.3332 20.9867Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66659 13.0133C4.41326 13.0133 4.15992 12.92 3.95992 12.72C3.57326 12.3333 3.57326 11.6933 3.95992 11.3067L10.6399 4.62667C11.0266 4.24 11.6666 4.24 12.0533 4.62667C12.4399 5.01334 12.4399 5.65334 12.0533 6.04L5.37326 12.72C5.18659 12.9067 4.91992 13.0133 4.66659 13.0133Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3332 13.0133H4.6665C4.11984 13.0133 3.6665 12.56 3.6665 12.0133C3.6665 11.4666 4.11984 11.0133 4.6665 11.0133H27.3332C27.8798 11.0133 28.3332 11.4666 28.3332 12.0133C28.3332 12.56 27.8798 13.0133 27.3332 13.0133Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.1
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithdraw);
export default __webpack_public_path__ + "static/media/withdraw.80db86e14a4df4ff8b725f3884de3c65.svg";
export { ForwardRef as ReactComponent };